

export const wanHero = {
    title: 'Wan 2.5：原生音频 AI 视频生成器',
    sub: '声音同步 • 唇形对齐 • 动态视觉 • 创作自由',
    desc:
      '阿里巴巴的 Wan 2.5 可生成带原生音频的视频：对白、音乐与音效与画面同步。支持文字或图片生成 10 秒视频（720p/1080p），提供最大创作自由，无需后期配音。'
  };
